import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { Convenio } from '../_models/convenio';

@Injectable({
  providedIn: 'root'
})
export class ConvenioService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/convenios/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as Convenio[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as Convenio ) );
  }

  crear( regCrear: Convenio ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as Convenio ) );
  }

  actualizar( regActualizar: Convenio ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
